const BADGE_OPTIONS = [
  {
    type: 'flat',
    data: (
      <img
        height="24px"
        alt="Static Badge"
        src="https://img.shields.io/badge/sample-cccccc?style=flat"
      />
    ),
  },
  {
    type: 'flat-square',
    data: (
      <img
        height="24px"
        alt="Static Badge"
        src="https://img.shields.io/badge/sample-cccccc?style=flat-square"
      />
    ),
  },
  {
    type: 'plastic',
    data: (
      <img
        height="24px"
        alt="Static Badge"
        src="https://img.shields.io/badge/sample-cccccc?style=plastic"
      />
    ),
  },
  {
    type: 'for-the-badge',
    data: (
      <img
        height="24px"
        alt="Static Badge"
        src="https://img.shields.io/badge/sample-cccccc?style=for-the-badge"
      />
    ),
  },
  {
    type: 'social',
    data: (
      <img
        height="24px"
        alt="Static Badge"
        src="https://img.shields.io/badge/sample-cccccc?style=social"
      />
    ),
  },
];

export default BADGE_OPTIONS;
